import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import { Report } from 'components/Report/Report';
import { convertUTCToLocalDate } from 'components/UTC/UtcConverter';
import { formatPhoneNumber } from 'react-phone-number-input';

import React from "react";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import { BillingReportByAccount } from "./BillingReportByAccount";

import { formatDate } from 'helper/dateFormat';
import { numberFormat } from 'helper/numberFormat';
import moment from 'moment';
import ExportOptions from '../../../components/ExportOptions/ExportOptions';
import { PaymentReportByPaymentMethod } from './PaymentReportByPaymentMethod';
import "./index.scss";
import { fontConfig } from "theme/fontConfig";
const report1 = ({
  filter,
  type,
  data: init,
  reportIndex,
  reportName,
  filterData,
  reportsFiltersPayload,
  downloadFile = false,
  isExportLoading,
  setIsExportLoading,
  totals,
  formik
}) => {
  const includeAccountInformation = formik?.values?.account?.includeAccountInformation;
  const tableContainerRef = React.createRef();

  const data =
    init?.length > 1 && reportIndex == "0"
      ? init
      : // init?.filter((el) => el?.total > 0)
        init;
  const dateFormet = "MM/DD/YYYY";
  const today = new Date();
  const AgedByLedgerheaders=["Category","total","0-30 Days","30-60 Days","60-90 Days","over 90 Days","Prepays"]
  const BillingByLedgerheaders=["Category","#Families","Billed","Paid*","Adjustments*","Balance"]
  const AgedAccountsheaders=["","Total","0-30 Days","30-60 Days","60-90 Days","over 90 Days","Prepays"]
  const LedgerAccountSummaryheaders =["Category","Total","0-30 Days","30-60 Days","60-90 Days","over 90 Days","Prepays"]
  const LedgerReport=["BatchNum","LedgerDate","Debit","Credit","Net Change"]
  const TableCellHead = withStyles((theme) => ({

    root: {
        borderBottom: 'none',
        background: '#EAEEFC',
        height: '35px',
        color:'#002E5C',
        fontWeight:'600',
        fontSize: '10px',
        fontFamily:fontConfig.GeneralTableCellHeadFont.family,
        lineHeight: '120.023%',
        textTransform:'uppercase',
        maxWidth:33,
        '&:first-child': {
          padding: '16px 7px 16px 16px !important'
        },
        '&:last-child': {
          padding: '16px 16px 16px 7px !important'
        },
    },
}))(TableCell);
 
  const TableCellBody = withStyles((theme) => ({
    root: {
        height: '40px',
        fontFamily: fontConfig.GeneralTableCellBodyFont.family,
        backgroundColor:'#fff',
        border:'none',
        maxWidth:33,
        padding: '7px',
        wordBreak: 'break-word',
        
    },
}))(TableCell);
const TableCellBodyTotal = withStyles((theme) => ({
  root: {
    height: '40px',
    backgroundColor:'#fff',
    borderBottom:'1px solid #81818C !important',
    color: '#3D3E46',
    fontFamily: fontConfig.ReportsTableCellBodyTotalFont.family,
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 'bolder',
    lineHeight: '120.023%',
    wordBreak: 'break-word',
  },
}))(TableCell);
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&.MuiTableRow-root': {
      backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
      border: 0,
  },
}));
let report2data = data?.map((item) => {
  return item?.records?.map((tran) => {
    return tran;
  });
});


const removeUnderlineHandler = (value) => {
  if(!value && value === null && !value?.length) return "";
  value = value?.charAt(0).toUpperCase() + value?.slice(1);
  return value?.replace(/_/g, " ");
};

  const report1Cols = [
    {
      id: "category",
      displayName: "CATEGORY",
      headerName: "Category",
      field: "category",
      flex: 1,
    },
    {
      id: "total",
      displayName: "TOTAL",
      headerName: "Total",
      field: "total",
      flex: 1,
    },
    {
      id: "thirtydays",
      displayName: "0-30DAYS",
      headerName: "0-30Days",
      field: "thirtydays",
      flex: 1,
    },

    {
      id: "sixtydays",
      displayName: "30-60DAYS",
      headerName: "30-60Days",
      field: "sixtydays",
      flex: 1,
    },
    {
      id: "nintydays",
      displayName: "60-90DAYS",
      headerName: "60-90Days",
      field: "nintydays",
      flex: 1,
    },
    {
      id: "overninty",
      displayName: "OVER 90DAYS",
      headerName: "over 90Days",
      field: "overninty",
      flex: 1,
    },
    {
      id: "prepays",
      displayName: "PREPAYS",
      headerName: "Prepays",
      field: "prepays",
      flex: 1,
    },
  ];

  const report1rows = () => {
    const arr = [];
    if (data) {
      data.map((item) => {
        const d = {
          category: item?.categoryName,
          total: item?.total?.toFixed(2),
          thirtydays:
            item?.transactions
              ?.find((tran) => tran?.date === "0-30")
              ?.totalAmount?.toFixed(2) ?? "0.00",
          sixtydays:
            item?.transactions
              ?.find((tran) => tran?.date == "30-60")
              ?.totalAmount?.toFixed(2) ?? "0.00",
          nintydays:
            item?.transactions
              ?.find((tran) => tran?.date == "60-90")
              ?.totalAmount?.toFixed(2) ?? "0.00",
          overninty:
            item?.transactions
              ?.find((tran) => tran?.date == "90+")
              ?.totalAmount?.toFixed(2) ?? "0.00",
          prepays:
            item?.transactions
              ?.find((tran) => tran?.date == "Prepays")
              ?.totalAmount?.toFixed(2) ?? "0.00",
        };
        arr.push(d);
      });
      const total = {
        category: "Total",
        total: totals?.totalsCalc,
        thirtydays: totals?.totalOf30Days,
        sixtydays: totals?.totalOf60Days,
        nintydays: totals?.totalOf90Days,
        overninty: totals?.totalOfOver90Days,
        prepays: totals?.totalPrepaysCalc,
      };
      arr.push(total);
    }
    return arr;
  };

  const report2Cols = [
    {
      id: "accountName",
      displayName: "ACCOUNT NAME",
      headerName: "Account Name",
      field: "Account Name",
      flex: 1,
    },
    {
      id: "category",
      displayName: "CATEGORY",
      headerName: "category",
      field: "category",
      flex: 1,
    },

    {
      id: "thirtydays",
      displayName: "0-30DAYS",
      headerName: "0-30Days",
      field: "thirtydays",
      flex: 1,
    },

    {
      id: "sixtydays",
      displayName: "30-60DAYS",
      headerName: "30-60Days",
      field: "sixtydays",
      flex: 1,
    },
    {
      id: "nintydays",
      displayName: "60-90DAYS",
      headerName: "60-90Days",
      field: "nintydays",
      flex: 1,
    },
    {
      id: "overninty",
      displayName: "over 90DAYS",
      headerName: "over 90Days",
      field: "overninty",
      flex: 1,
    },
    {
      id: "prepays",
      displayName: "PREPAYS",
      headerName: "Prepays",
      field: "prepays",
      flex: 1,
    },
    ...(includeAccountInformation ? [
      {
        id: "adult1firstName",
        displayName: "ADULT 1 FIRST NAME",
        headerName: "Adult 1 First Name",
        field: "adult1firstName",
        flex: 1,
      },
      {
        id: "adult1lastName",
        displayName: "ADULT 1 LAST NAME",
        headerName: "Adult 1 Last Name",
        field: "adult1lastName",      
        flex: 1,
      },
      {
        id: "adult2firstName",
        displayName: "ADULT 2 FIRST NAME",
        headerName: "Adult 2 First Name",
        field: "adult2firstName",
        flex: 1,
      },
      {
        id: "adult2lastName",
        displayName: "ADULT 2 LAST NAME",
        headerName: "Adult 2 Last Name",
        field: "adult2lastName",      
        flex: 1,
      },
      {
        id: "billingAddress",
        displayName: "BILLING ADDRESS",
        headerName: "Billing Address",
        field: "billingAddress",
        flex: 1,
      },
      {
        id: "billingCity",
        displayName: "BILLING CITY",
        headerName: "Billing City",
        field: "billingCity",
        flex: 1,
      },
      {
        id: "billingState",
        displayName: "BILLING STATE",
        headerName: "Billing State",
        field: "billingState",
        flex: 1,
      },
      {
        id: "billingZip",
        displayName: "BILLING ZIP CODE",
        headerName: "Billing Zip Code",
        field: "billingZip",
        flex: 1,
      },
      {
        id: "billingCountry",
        displayName: "BILLING COUNTRY",
        headerName: "Billing Country",
        field: "billingCountry",
        flex: 1,
      },
      {
        id: "adult1Mobile",
        displayName: "ADULT 1 MOBILE",
        headerName: "Adult 1 Mobile",
        field: "adult1Mobile",
        flex: 1,
      },
      {
        id: "adult2Mobile",
        displayName: "ADULT 2 MOBILE",
        headerName: "Adult 2 Mobile",
        field: "adult2Mobile",
        flex: 1,
      },
      {
        id: "adult1Email",
        displayName: "ADULT 1 EMAIL",
        headerName: "Adult 1 Email",
        field: "adult1Email",
        flex: 1,
      },
      {
        id: "adult2Email",
        displayName: "ADULT 2 EMAIL",
        headerName: "Adult 2 Email",
        field: "adult2Email",
        flex: 1,
      },  
    ] : []),
  ];
  

  const report2rows = () => {
    const arr = [];
    if (report2data) {
      data.map((item) => {
          const it = item?.records?.map((record) => {
          const d = {
            accountName: item?.accountName,
            category: ` ${`${record?.Ledger ? record?.Ledger : ""}/ ${
              record?.SubLedger ? record?.SubLedger : ""
            }`}`,
            thirtydays:
              record?.transactions
                ?.find((o, i) => {
                  if (o.date === "0-30") {
                    return o;
                  }
                })
                ?.totalAmount?.toFixed(2) ?? 0,

            sixtydays:
              record?.transactions?.find((o, i) => {
                if (o.date === "30-60") {
                  return o;
                }
              })?.totalAmount ?? 0,
            nintydays:
              record?.transactions?.find((o, i) => {
                if (o.date === "60-90") {
                  return o;
                }
              })?.totalAmount ?? 0,
            overninty:
              record?.transactions?.find((o, i) => {
                if (o.date === "90+") {
                  return o;
                }
              })?.totalAmount ?? 0,
            prepays:
              record?.transactions?.find((o, i) => {
                if (o.date === "Prepays") {
                  return o;
                }
              })?.totalAmount ?? 0,
              ...(includeAccountInformation ? {
                adult1firstName: item?.account?.["Adult 1 First Name"],
                adult1lastName: item?.account?.["Adult 1 Last Name"],
                adult2firstName: item?.account?.["Adult 2 First Name"],
                adult2lastName: item?.account?.["Adult 2 Last Name"],
                billingAddress: item?.account?.Address1,
                billingCity: item?.account?.Address1_City,
                billingState: item?.account?.Address1_State,
                billingZip: item?.account?.Address1_Zip_Code,
                billingCountry: item?.account?.Address1_Country,
                adult1Mobile: formatPhoneNumber(item?.account?.["Adult 1 Mobile"]),
                adult2Mobile: formatPhoneNumber(item?.account?.["Adult 2 Mobile"]),
                adult1Email: item?.account?.["Adult 1 Email"],
                adult2Email: item?.account?.["Adult 2 Email"],
              } : {}),
              
          };
          arr.push({ accountName: item.accountName, ...d });
        });
        const total = {
          accountName: "Total",
          category: "",
          thirtydays: item?.records?.map((hh) => {
                        return (
                          hh?.transactions?.find((o, i) => {
                            if (o.date === "0-30") {
                              return o;
                            }
                          })?.totalAmount ?? 0
                        );
                      })?.reduce((partialSum, a) => partialSum + a, 0)?.toFixed(2),
          sixtydays: item?.records
          ?.map((hh) => {
            return (
              hh?.transactions?.find((o, i) => {
                if (o.date === "30-60") {
                  return o;
                }
              })?.totalAmount ?? 0
            );
          })
          ?.reduce((partialSum, a) => partialSum + a, 0)
          ?.toFixed(2),
          nintydays: item?.records
          ?.map((hh) => {
            return (
              hh?.transactions?.find((o, i) => {
                if (o.date === "60-90") {
                  return o;
                }
              })?.totalAmount ?? 0
            );
          })
          ?.reduce((partialSum, a) => partialSum + a, 0)
          ?.toFixed(2),
          overninty: item?.records
          ?.map((hh) => {
            return (
              hh?.transactions?.find((o, i) => {
                if (o.date === "90+") {
                  return o;
                }
              })?.totalAmount ?? 0
            );
          })
          ?.reduce((partialSum, a) => Number(partialSum + a, 0))
          ?.toFixed(2),
          prepays: item?.records
          ?.map((hh) => {
            return (
              hh?.transactions?.find((o, i) => {
                if (o.date === "Prepays") {
                  return o;
                }
              })?.totalAmount ?? 0
            );
  
          })
          ?.reduce((partialSum, a) => partialSum + a, 0)
          ?.toFixed(2),
        };
        arr.push(total);
      });


    }
    return arr;
  };

  ////////////////////// Report 4 ///////////////\
  const report4Cols = [
    {
      id: "batch#",
      displayName: "BATCH#",
      headerName: "Batch#",
      field: "batch#",
      flex: 1,
    },
    {
      id: "date",
      displayName: "DATE",
      headerName: "Date",
      field: "Date",
      flex: 1,
    },
    {
      id: "accountReceiveable",
      displayName: "A/R",
      headerName: "A/R",
      field: "a/r",
      flex: 1,
    },
    {
      id: "batch",
      displayName: "BATCH",
      headerName: "Batch",
      field: "batch",
      flex: 1,
    },
    {
      id: "debit",
      displayName: "DEBIT",
      headerName: "Debit",
      field: "debit",
      flex: 1,
    },
    {
      id: "credit",
      displayName: "CREDIT",
      headerName: "Credit",
      field: "credit",
      flex: 1,
    },
  ];
  const report4rows = () => {
    const arr = [];
    if (data) {
      data.map((item) => {
        return item?.transactions?.map((tran) => {
          const d = {
            ["batch#"]: item?._id,
            date: moment(item?.date).format(dateFormet),
            accountReceiveable:
              tran?.accountReceivableLedger?.id?.ar_name ?? "-",
            batch: tran?.account?.name,
            debit: tran?.debit?.toFixed(2),
            credit: tran?.credit?.toFixed(2),
          };
          arr.push(d);
        });
      });
    }
    return arr;
  };

  const report3Cols = [
    {
      id: "category",
      displayName: "CATEGORY",
      headerName: "Category",
      field: "category",
      flex: 1,
    },
    {
      id: "families",
      displayName: "#FAMILIES",
      headerName: "#Families",
      field: "families",
      flex: 1,
    },
    {
      id: "billed",
      displayName: "BILLED",
      headerName: "Billed",
      field: "billed",
      flex: 1,
    },
    {
      id: "paid",
      displayName: "PAID",
      headerName: "Paid",
      field: "paid",
      flex: 1,
    },
    {
      id: "adjustments",
      displayName: "ADJUSTMENTS",
      headerName: "Adjustments",
      field: "adjustments",
      flex: 1,
    },
    {
      id: "balance",
      displayName: "BALANCE",
      headerName: "Balance",
      field: "balance",
      flex: 1,
    },
  ];
  const report3rows = () => {
    const arr = [];
    if (data) {
      data.map((item) => {
        const d = {
          category: `${item?.Ledger}/${item?.SubLedger}`,
          families: item?.families,
          billed: item?.billed?.toFixed(2),
          paid: item?.paid?.toFixed(2),
          adjustments: item?.adjusted?.toFixed(2),
          balance: item?.balance?.toFixed(2),
        };
        arr.push(d);
      });
      const total = {
        category: "Total",
        families: totals?.totalsOfFamilies,
        billed: totals?.totalsOfBilled,
        paid: totals?.totalsOfPaid,
        adjustments: totals?.totalsOfAdjusted,
        balance: totals?.totalsOfBalance,
      };
      arr.push(total);
    }
    return arr;
  }; ////////////////////// Report 5 ///////////////\

  const report5Cols = [
    {
      id: "BatchNum#",
      displayName: "BATCHNUM#",
      headerName: "BatchNum#",
      field: "BatchNum#",
      flex: 1,
    },
    {
      id: "LedgerDate",
      displayName: "LEDGERDATE",
      headerName: "LedgerDate",
      field: "LedgerDate",
      flex: 1,
    },
    {
      id: "debit",
      displayName: "DEBIT",
      headerName: "Debit",
      field: "debit",
      flex: 1,
    },
    {
      id: "credit",
      displayName: "CREDIT",
      headerName: "Credit",
      field: "credit",
      flex: 1,
    },
    {
      id: "netCharge",
      displayName: "NET CHANGE",
      headerName: "Net Change",
      field: "netCharge",
      flex: 1,
    },
  ];


  const report5rows = () => {
    const arr = [];
    if (data) {
      data.map((item) => {
        const itemObj = item?.transactions?.map((tran) => {
          const d = {
            ["BatchNum#"]: tran?.batchId,
            LedgerDate: moment(tran?.date).format(dateFormet),
            debit: tran?.debit?.toFixed(2),
            credit: tran?.credit?.toFixed(2),
            netCharge: (tran?.debit + tran?.credit)?.toFixed(2),
          };
          arr.push(d);
        });
        const total = {
          ["BatchNum#"]: "Total",
          LedgerDate: "",
          debit: item?.transactions?.map((tran) => {
            return tran?.debit;
          })?.reduce((partialSum, a) => partialSum + a, 0) ? 
              (+item?.transactions
                ?.map((tran) => {
                  return tran?.debit;
                })
                ?.reduce(
                  (partialSum, a) => partialSum + a,
                  0
                )).toFixed(2)
            
          : "0.00",
          credit: item?.transactions?.map((tran) => {
            return tran?.credit;
          })?.reduce((partialSum, a) => partialSum + a, 0)
          ? 
              (+item?.transactions
                ?.map((tran) => {
                  return tran?.credit;
                })
                ?.reduce(
                  (partialSum, a) => partialSum + a,
                  0
                )).toFixed(2)
            
          : "0.00",
          netCharge: item?.transactions
          ?.map((tran) => {
            return tran?.debit;
          })?.reduce((partialSum, a) => partialSum + a, 0) + item?.transactions?.map((tran) => {
            return tran?.credit;
          })
          ?.reduce((partialSum, a) => partialSum + a, 0)
          ? 
              (
                +item?.transactions
                  ?.map((tran) => {
                    return tran?.debit;
                  })
                  ?.reduce((partialSum, a) => partialSum + a, 0) +
                item?.transactions
                  ?.map((tran) => {
                    return tran?.credit;
                  })
                  ?.reduce((partialSum, a) => partialSum + a, 0)
              ).toFixed(2)
            
          : "0.00"
        };
        arr.push(total);
        
          
      });
    }
    return arr;
  };
  const report6Cols = [
    {
      id: "category",
      displayName: "CATEGORY",
      headerName: "Category",
      field: "category",
      flex: 1,
    },
    {
      id: "total",
      displayName: "TOTAL",
      headerName: "Total",
      field: "total",
      flex: 1,
    },
    {
      id: "thirtydays",
      displayName: "0-30DAYS",
      headerName: "0-30Days",
      field: "thirtydays",
      flex: 1,
    },

    {
      id: "sixtydays",
      displayName: "30-60DAYS",
      headerName: "30-60Days",
      field: "sixtydays",
      flex: 1,
    },
    {
      id: "nintydays",
      displayName: "60-90DAYS",
      headerName: "60-90Days",
      field: "nintydays",
      flex: 1,
    },
    {
      id: "overninty",
      displayName: "over 90DAYS",
      headerName: "over 90Days",
      field: "overninty",
      flex: 1,
    },
    {
      id: "prepays",
      displayName: "PREPAYS",
      headerName: "Prepays",
      field: "prepays",
      flex: 1,
    },
  ];
  const report6rows = () => {
    const arr = [];
    if (data) {
      data.map((item) => {
        const d = {
          category: `${item?.Ledger}/${item?.SubLedger}`,
          total: item?.total?.toFixed(2),
          thirtydays: item?.transactions
            ?.find((tran) => tran?.date === "0-30")
            ?.totalAmount?.toFixed(2),
          sixtydays: item?.transactions
            ?.find((tran) => tran?.date == "30-60")
            ?.totalAmount?.toFixed(2),
          nintydays: item?.transactions
            ?.find((tran) => tran?.date == "60-90")
            ?.totalAmount?.toFixed(2),
          overninty: item?.transactions
            ?.find((tran) => tran?.date == "90+")
            ?.totalAmount?.toFixed(2),
          prepays: item?.transactions
            ?.find((tran) => tran?.date == "Prepays")
            ?.totalAmount?.toFixed(2),
        };
        arr.push(d);
      });
      const total = {
        category: "Total",
        total: totals?.ledgerTotalsCalc ? totals?.ledgerTotalsCalc?.toFixed(2) : "0.00",
        thirtydays: totals?.totalOf30Days ? totals?.totalOf30Days?.toFixed(2) : "0.00",
        sixtydays: totals?.totalOf60Days ? totals?.totalOf60Days?.toFixed(2) : "0.00",
        nintydays: totals?.totalOf90Days ? totals?.totalOf90Days?.toFixed(2) : "0.00",
        overninty: totals?.totalOfOver90Days ? totals?.totalOfOver90Days.toFixed(2) : "0.00",
        prepays: totals?.ledgerTotalPrepaysCalc ? totals?.ledgerTotalPrepaysCalc.toFixed(2) : "0.00",
      };
      arr.push(total);
    }
    return arr;
  };
  const billingReportRows = () => {
    const arr = [];
      data.map((val) => {
        return val?.data?.map((item,index) => {
          const d = {
            ...(reportName === "Billing Report by Account (Family)" ? {accountId:item?.account?.account_id ? `#${item?.account?.account_id}` : '',
            accountName:item?.AccountName,
          } : {
            ledgerName:item?.ledgerName,
          }),
            billed:item?.billed?.toFixed(2),
            discount:item?.discount?.toFixed(2),
            paid:item?.paid?.toFixed(2),
            balance:item?.balance?.toFixed(2),
            ...(includeAccountInformation ? {
              adult1firstName: item?.account?.["Adult 1 First Name"],
              adult1lastName: item?.account?.["Adult 1 Last Name"],
              adult2firstName: item?.account?.["Adult 2 First Name"],
              adult2lastName: item?.account?.["Adult 2 Last Name"],
              billingAddress: item?.account?.Address1,
              billingCity: item?.account?.Address1_City,
              billingState: item?.account?.Address1_State,
              billingZip: item?.account?.Address1_Zip_Code,
              billingCountry: item?.account?.Address1_Country,
              adult1Mobile: formatPhoneNumber(item?.account?.["Adult 1 Mobile"]),
              adult2Mobile: formatPhoneNumber(item?.account?.["Adult 2 Mobile"]),
              adult1Email: item?.account?.["Adult 1 Email"],
              adult2Email: item?.account?.["Adult 2 Email"],
            } : {}),
          };
          arr.push({...d});
        });
        
      });
      const total={
      
        ...(reportName === "Billing Report by Account (Family)" ? {
          accountId:  "Total for this report",
          accountName:""
        } : {
          ledgerName: "Total",
        }),        
        billed:data[0]?.totalBilled?.toFixed(2),
        discount: data[0]?.totalDiscount?.toFixed(2),
        paid:data[0]?.totalPaid?.toFixed(2),
        balance:data[0]?.totalBalance?.toFixed(2)
      }
      arr.push({...total});
    return arr;

  };

  const billingReportDetailsRows = () => {
    const arr = [];
      let report2new = data?.map((val) => {
        return val?.data?.map((ledger,index) => {
          return ledger?.[reportName === "Billing Report by Ledger" ? "accounts" : "ledgers"].map((item)=>{
          const d = {
            ...(reportName === "Billing Report by Account (Family)" ? {
              accountName:ledger?.AccountName,
              ledgers:  item?.ledgerName,
            } : {
              ledgers:  ledger?.ledgerName,
              accountName:item?.accountName,
            }),
            billed:item?.billed?.toFixed(2),
            discount:item?.discount?.toFixed(2),
            paid:item?.paid?.toFixed(2),
            balance:item?.balance?.toFixed(2),
            ...(includeAccountInformation && reportName === "Billing Report by Ledger" ? {
              adult1firstName: item?.["Adult 1 First Name"],
              adult1lastName: item?.["Adult 1 Last Name"],
              adult2firstName: item?.["Adult 2 First Name"],
              adult2lastName: item?.["Adult 2 Last Name"],
              billingAddress: item?.Address1,
              billingCity: item?.Address1_City,
              billingState: item?.Address1_State,
              billingZip: item?.Address1_Zip_Code,
              billingCountry: item?.Address1_Country,
              adult1Mobile: formatPhoneNumber(item?.["Adult 1 Mobile"]),
              adult2Mobile: formatPhoneNumber(item?.["Adult 2 Mobile"]),
              adult1Email: item?.["Adult 1 Email"],
              adult2Email: item?.["Adult 2 Email"],
            } : {}),
            ...(includeAccountInformation && reportName === "Billing Report by Account (Family)" ? {
              adult1firstName: ledger?.account?.["Adult 1 First Name"],
              adult1lastName: ledger?.account?.["Adult 1 Last Name"],
              adult2firstName: ledger?.account?.["Adult 2 First Name"],
              adult2lastName: ledger?.account?.["Adult 2 Last Name"],
              billingAddress: ledger?.account?.Address1,
              billingCity: ledger?.account?.Address1_City,
              billingState: ledger?.account?.Address1_State,
              billingZip: ledger?.account?.Address1_Zip_Code,
              billingCountry: ledger?.account?.Address1_Country,
              adult1Mobile: formatPhoneNumber(ledger?.account?.["Adult 1 Mobile"]),
              adult2Mobile: formatPhoneNumber(ledger?.account?.["Adult 2 Mobile"]),
              adult1Email: ledger?.account?.["Adult 1 Email"],
              adult2Email: ledger?.account?.["Adult 2 Email"],
            } : {}),
     
          };
          arr.push(d);
          })
         
        });
      });
      const total={
        ...(reportName === "Billing Report by Account (Family)" ? {
          accountName:"Total",
          ledgers:"",
        } : {
          ledgers: "Total",
          accountName:"",
        }),
        billed:data[0]?.totalBilled?.toFixed(2),
        discount: data[0]?.totalDiscount?.toFixed(2),
        paid:data[0]?.totalPaid?.toFixed(2),
        balance:data[0]?.totalBalance?.toFixed(2)
      }
      arr.push({...total});
    return arr;
  };

  // Payment Report By Payment Method rows
  const paymentReportRows = () => {
    const arr = [];
      data.map((val) => {
        return val?.data?.map((item,index) => {
          const d = {
            paymentMethod:removeUnderlineHandler(item?.paymentMethod),
            amount:item?.totalAmount?.toFixed(2)
          };
          arr.push({...d});
        });
        
      });
      const total={
        paymentMethod: "Total",
        amount:data[0]?.total?.toFixed(2)
      }
      arr.push({...total});
    return arr;
  };
  
  const paymentReportDetailsRows = () => {
    const arr = [];
      let report2new = data?.map((val) => { 
        return val?.data?.map((payment,index) => {
          return payment?.payments.map((item)=>{
          const d = {
            paymentMethod:removeUnderlineHandler(payment?.paymentMethod),
            paymentDate: item?.date ? formatDate({date:item?.date, formatType: "default"}) : "",
            paymentId: item?.paymentId,
            batchId: item?.batchId,
            amount:item?.amount?.toFixed(2)
          };
          arr.push(d);
          })
      });
    });
      const total={
        paymentMethod: "Total",
        paymentDate: `${data?.[0]?.totalOfPaymentMethod} Payment Method`,
        paymentId: "",
        batchId: "",
        amount:data?.[0]?.total?.toFixed(2)
      }
      arr.push({...total});
    return arr;
  };




  let report2Data = [];
  const getReport2 = () => {
    if (reportIndex == 1) {
      let report2new = data?.map((item) => {
        const itemObj = item?.records?.map((record) => {
          const d = {
            ["Account Name"]: item?.accountName,
            Category: ` ${`${record?.Ledger ? record?.Ledger : ""}/ ${
              record?.SubLedger ? record?.SubLedger : ""
            }`}`,
            ["0-30 Days"]:
              record?.transactions
                ?.find((o, i) => {
                  if (o.date === "0-30") {
                    return o;
                  }
                })
                ?.totalAmount?.toFixed(2) ?? 0,
            ["30-60 Days"]:
              record?.transactions?.find((o, i) => {
                if (o.date === "30-60") {
                  return o;
                }
              })?.totalAmount ?? 0,
            ["60-90 Days"]:
              record?.transactions?.find((o, i) => {
                if (o.date === "60-90") {
                  return o;
                }
              })?.totalAmount ?? 0,
            ["over 90 Days"]:
              record?.transactions?.find((o, i) => {
                if (o.date === "90+") {
                  return o;
                }
              })?.totalAmount ?? 0,
            ["Prepays"]:
              record?.transactions?.find((o, i) => {
                if (o.date === "Prepays") {
                  return o;
                }
              })?.totalAmount ?? 0,
              ...(includeAccountInformation ? {
                adult1firstName: item?.account?.["Adult 1 First Name"],
                adult1lastName: item?.account?.["Adult 1 Last Name"],
                adult2firstName: item?.account?.["Adult 2 First Name"],
                adult2lastName: item?.account?.["Adult 2 Last Name"],
                billingAddress: item?.account?.Address1,
                billingCity: item?.account?.Address1_City,
                billingState: item?.account?.Address1_State,
                billingZip: item?.account?.Address1_Zip_Code,
                billingCountry: item?.account?.Address1_Country,
                adult1Mobile: formatPhoneNumber(item?.account?.["Adult 1 Mobile"]),
                adult2Mobile: formatPhoneNumber(item?.account?.["Adult 2 Mobile"]),
                adult1Email: item?.account?.["Adult 1 Email"],
                adult2Email: item?.account?.["Adult 2 Email"],
              } : {}),
            };
          report2Data.push(d);
        });
        const total = {
          ["Account Name"]: "Total",
          Category: "",
          ["0-30 Days"]: item?.records?.map((hh) => {
                        return (
                          hh?.transactions?.find((o, i) => {
                            if (o.date === "0-30") {
                              return o;
                            }
                          })?.totalAmount ?? 0
                        );
                      })?.reduce((partialSum, a) => partialSum + a, 0)?.toFixed(2),
          ["30-60 Days"]: item?.records
          ?.map((hh) => {
            return (
              hh?.transactions?.find((o, i) => {
                if (o.date === "30-60") {
                  return o;
                }
              })?.totalAmount ?? 0
            );
          })
          ?.reduce((partialSum, a) => partialSum + a, 0)
          ?.toFixed(2),
          ["60-90 Days"]: item?.records
          ?.map((hh) => {
            return (
              hh?.transactions?.find((o, i) => {
                if (o.date === "60-90") {
                  return o;
                }
              })?.totalAmount ?? 0
            );
          })
          ?.reduce((partialSum, a) => partialSum + a, 0)
          ?.toFixed(2),
          ["over 90 Days"]: item?.records
          ?.map((hh) => {
            return (
              hh?.transactions?.find((o, i) => {
                if (o.date === "90+") {
                  return o;
                }
              })?.totalAmount ?? 0
            );
          })
          ?.reduce((partialSum, a) => Number(partialSum + a, 0))
          ?.toFixed(2),
          ["Prepays"]: item?.records
          ?.map((hh) => {
            return (
              hh?.transactions?.find((o, i) => {
                if (o.date === "Prepays") {
                  return o;
                }
              })?.totalAmount ?? 0
            );
  
          })
          ?.reduce((partialSum, a) => partialSum + a, 0)
          ?.toFixed(2),
        };
        report2Data.push(total);
      });
    }
  };


  const agedAccountByLedgerRows = () => {
    let arr = [];
    let rows = data?.map((item) => {
      const itemObj = {
        Category: item?.categoryName,
        total: item?.total?.toFixed(2),
        ["0-30 Days"]:
          item?.transactions
            ?.find((tran) => tran?.date === "0-30")
            ?.totalAmount?.toFixed(2) ?? "0.00",
        ["30-60 Days"]:
          item?.transactions
            ?.find((tran) => tran?.date == "30-60")
            ?.totalAmount?.toFixed(2) ?? "0.00",
        ["60-90 Days"]:
          item?.transactions
            ?.find((tran) => tran?.date == "60-90")
            ?.totalAmount?.toFixed(2) ?? "0.00",
        ["over 90 Days"]:
          item?.transactions
            ?.find((tran) => tran?.date == "90+")
            ?.totalAmount?.toFixed(2) ?? "0.00",
        ["Prepays"]:
          item?.transactions
            ?.find((tran) => tran?.date == "Prepays")
            ?.totalAmount?.toFixed(2) ?? "0.00",
      };
      arr.push(itemObj);
    });
    const total = {
      Category: "Total",
      total: totals?.totalsCalc,
      ["0-30 Days"]: totals?.totalOf30Days,
      ["30-60 Days"]: totals?.totalOf60Days,
      ["60-90 Days"]: totals?.totalOf90Days,
      ["over 90 Days"]: totals?.totalOfOver90Days,
      ["Prepays"]: totals?.totalPrepaysCalc,
    };
    arr.push(total);
    return arr;
  };


  const billingSummarizedByLedgerRows = () => {
      let arr = [];
      const rows = data?.map((item) => {
        const itemObj = {
          Category: `${item?.Ledger} /${item?.SubLedger} `,
          Families: item?.families,
          Billed: item?.billed?.toFixed(2),
          Paid: item?.paid?.toFixed(2),
          Adjustments: item?.adjusted?.toFixed(2),
          Balance: item?.balance?.toFixed(2),
        };
        arr.push(itemObj);
      })
      const total = {
        Category: "Total",
        Families: totals?.totalsOfFamilies,
        Billed: totals?.totalsOfBilled,
        Paid: totals?.totalsOfPaid,
        Adjustments: totals?.totalsOfAdjusted,
        Balance: totals?.totalsOfBalance,
      };
      arr.push(total);
      return arr;
  }


  const ledgerAccountSummaryRows = () => {
    let arr = [];
    const rows = data?.map((item) => {
      const itemObj = {
        Category: `${item?.Ledger}/${item?.SubLedger}`,
        total: item?.total?.toFixed(2),
        ["0-30 Days"]:
          item?.transactions
            ?.find((tran) => tran?.date === "0-30")
            ?.totalAmount?.toFixed(2) ?? "0.00",
        ["30-60 Days"]:
          item?.transactions
            ?.find((tran) => tran?.date == "30-60")
            ?.totalAmount?.toFixed(2) ?? "0.00",
        ["60-90 Days"]:
          item?.transactions
            ?.find((tran) => tran?.date == "60-90")
            ?.totalAmount?.toFixed(2) ?? "0.00",
        ["over 90 Days"]:
          item?.transactions
            ?.find((tran) => tran?.date == "90+")
            ?.totalAmount?.toFixed(2) ?? "0.00",
        ["Prepays"]:
          item?.transactions
            ?.find((tran) => tran?.date == "Prepays")
            ?.totalAmount?.toFixed(2) ?? "0.00",
      };
      arr.push(itemObj);
    })
    const total = {
      Category: "Total",
      total: totals?.ledgerTotalsCalc ? totals?.ledgerTotalsCalc?.toFixed(2) : "0.00",
      ["0-30 Days"]: totals?.totalOf30Days ? totals?.totalOf30Days?.toFixed(2) : "0.00",
      ["30-60 Days"]: totals?.totalOf60Days ? totals?.totalOf60Days?.toFixed(2) : "0.00",
      ["60-90 Days"]: totals?.totalOf90Days ? totals?.totalOf90Days?.toFixed(2) : "0.00",
      ["over 90 Days"]: totals?.totalOfOver90Days ? totals?.totalOfOver90Days.toFixed(2) : "0.00",
      ["Prepays"]: totals?.ledgerTotalPrepaysCalc ? totals?.ledgerTotalPrepaysCalc.toFixed(2) : "0.00",
    };
    arr.push(total);
    return arr;
  };

  const creditOnAccountCols = [
    { id: "Account ID", displayName: "Account ID" },
    { id: "Account Name", displayName: "Account Name" },
    { id: "Balance", displayName: "Balance" },
  ];

  const creditOnAccountRows = () => {
    const arr = data?.map((item) => ({
      "Account ID": `#${item?.accountId}`,
      "Account Name": item?.accountName,
      "Balance": (+item?.balance || 0).toFixed(2),
    })) || [];
    const totalBalance = data?.reduce((sum, item) => sum + (+item?.balance || 0), 0);
    arr.push({ "Account ID": "Total", "Account Name": "", "Balance": totalBalance.toFixed(2) });
    return arr;
  };
  
  


  const reportFileNameHandler = () =>{
    const {date,dateRange} = filterData?.filter;
    const formattedStartDateRange = dateRange?.start ? moment(dateRange?.start).format("MM-DD-YYYY") : "";
    const formattedEndDateRange = dateRange?.end ? moment(dateRange?.end).format("MM-DD-YYYY") : "";
    const formattedDateRange = (formattedStartDateRange || formattedEndDateRange) ? `${formattedStartDateRange}_${formattedEndDateRange}` : ""
    const formattedDate = date ? moment(date).format("MM-DD-YYYY") : "";
    const reportFileName = `${reportName}_${formattedDateRange ? formattedDateRange : formattedDate}`
    return reportFileName || "report"
  }

  const generateExcel = () => {
    setIsExportLoading(true);
    getReport2()    
    let res =
    reportName === "Billing Report by Account (Family)"  || reportName === "Billing Report by Ledger"
    ? filterData?.filter?.detailedByFamily ?
    billingReportDetailsRows()
    :billingReportRows()
      : reportName === "Payment by payment method type" ? filterData?.filter?.detailedByPaymentMethod ?
      paymentReportDetailsRows()
      : paymentReportRows()
      :
    reportName === "Aged account receivable summarized by Ledger" 
        ? agedAccountByLedgerRows()
        : reportName === "Billing Summarized by Ledger"
        ? billingSummarizedByLedgerRows()
        : reportName === "Aged account receivable summarized by Family"
        ? report2Data
        : reportName === "Batch details"
        ? report4rows()
        : reportName === "Ledger report"
        ? report5rows()
        : reportName === "Ledger account summary"
        ? ledgerAccountSummaryRows()
        : reportName === "Credit on Account"
        ? creditOnAccountRows()
        : "";

    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(res));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      reportName
        ? reportFileNameHandler() + ".xlsx"
        : "report.xlsx"
    );
    setIsExportLoading(false);
  };

  const downloadExcel = () => {
    generateExcel();
  };
  


  const billingReportTitle = (reportName) => {

  }
  return reportName === "Payment by payment method type" ? (
    <div
      className={ "report-doc p-10"}
      style={{
        zIndex: `${downloadFile ? "-999" : "0"}`,
      }}
    >
      <PaymentReportByPaymentMethod
        filters={filter}
        data={data}
        filterData={filterData}
        dateFormet={dateFormet}
        today={today}
        TableCellBodyTotal={TableCellBodyTotal}
        TableCellBody={TableCellBody}
        StyledTableRow={StyledTableRow}
        downloadExcel={downloadExcel}
        TableCellHead={TableCellHead}
        reportRows={paymentReportRows}
        reportDetailsRows={paymentReportDetailsRows}
        tableContainerRef={tableContainerRef}
        isLoading={isExportLoading}
        reportsFiltersPayload={reportsFiltersPayload}
        reportName={reportName}
        setIsExportLoading={setIsExportLoading}
        reportFileNameHandler={reportFileNameHandler}
        removeUnderlineHandler={removeUnderlineHandler}
      />
    </div>
  ) :
   reportName === "Billing Report by Account (Family)" || reportName === "Billing Report by Ledger" ? (
    <div
    className={ "report-doc p-10"}
    style={{
      zIndex: `${downloadFile ? "-999" : "0"}`,
    }}
  >
   <BillingReportByAccount
    filters={filter}
    data={data}
    filterData={filterData}
    dateFormet={dateFormet}
    today={today}
    TableCellBodyTotal={TableCellBodyTotal}
    TableCellBody={TableCellBody}
    StyledTableRow={StyledTableRow}
    downloadExcel={downloadExcel}
    TableCellHead={TableCellHead}
    reportRows={billingReportRows}
    reportDetailsRows={billingReportDetailsRows}
    tableContainerRef={tableContainerRef}
    isLoading={isExportLoading}
    reportsFiltersPayload={reportsFiltersPayload}
    reportName={reportName}
    setIsExportLoading={setIsExportLoading}
    reportFileNameHandler={reportFileNameHandler}
    includeAccountInformation={includeAccountInformation}
    />

  </div>
  ) : reportName === "Aged account receivable summarized by Ledger" ? (
    <div
    className={ "report-doc p-10"}
    style={{
      zIndex: `${downloadFile ? "-999" : "0"}`,

    }}
  >
    <ExportOptions 
      columns={report1Cols}
      datas={report1rows()}
      downloadExcel={downloadExcel}
      isLoading={isExportLoading}
      setLoading={setIsExportLoading}
      tableContainerRef={tableContainerRef}
      reportFileNameHandler={reportFileNameHandler}
    />
  
    <Report 
    Title={'Aged account receivable summarized by Ledger'}
    Filters={filter}
    FromDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.date), formatType: "default"})}
    ToDate={formatDate({date:today, formatType: "default"})}
    asOf={formatDate({date:today, formatType: "default"})}
    tableContainerRef={tableContainerRef}
    Content={
      <Table >
      <TableHead>
          <TableRow>
              {AgedByLedgerheaders?.map((item, index) => (
                  <TableCellHead align={index ===0?"left":"right"}
                  style={{  
                    borderBottomLeftRadius:index === 0 ? 5:0,
                    borderTopLeftRadius:index === 0 ? 5:0,
                    borderBottomRightRadius:AgedByLedgerheaders.length-1=== index ? 5:0,
                    borderTopRightRadius:AgedByLedgerheaders.length-1=== index ? 5:0,
                    padding: "16px 7px",

                    }}>
                      <span>
                          {item}
                      </span>
                  </TableCellHead>
              ))}
          </TableRow>
      </TableHead>
      <TableBody style={{ backgroundColor: 'white' }}>
              <>
              {data?.map((item)=>(
                <StyledTableRow sx={{
                  '& > *': {
                      borderBottom: 'unset'
                  }
              }}
              >
                  <TableCellBody
                      className="main-width-class first-cell"
                      align="left"
                  >
                    <div className="name">{item?.categoryName}</div> 
                  </TableCellBody>
                  <TableCellBody
                      className="main-width-class"
                      align="right"
                  >
                     {numberFormat({number:+item?.total, decimal: 2, style: "currency"})}
                  </TableCellBody>
                  <TableCellBody
                      className="main-width-class"
                      align="right"
                  >
                  {numberFormat({number:(+item?.transactions?.find((o, i) => {
                      if (o.date === "0-30") {
                        return o;
                      }
                    })?.totalAmount), decimal: 2, style: "currency"})}
                  </TableCellBody>
                  <TableCellBody
                      className="main-width-class"
                      align="right"
                  >
                    
                    {numberFormat({number:(+item?.transactions?.find((o, i) => {
                          if (o.date === "30-60") {
                            return o;
                          }
                        })?.totalAmount), decimal: 2, style: "currency"})}
                  </TableCellBody>
                  <TableCellBody
                      className="main-width-class"
                      align="right"
                  >
                     {numberFormat({number:(+item?.transactions?.find((o, i) => {
                      if (o.date === "60-90") {
                        return o;
                      }
                    })?.totalAmount), decimal: 2, style: "currency"})}
                  </TableCellBody>
                  <TableCellBody
                      className="main-width-class"
                      align="right"
                  >
                  {numberFormat({number:(+item?.transactions?.find((o, i) => {
                      if (o.date === "90+") {
                        return o;
                      }
                    })?.totalAmount), decimal: 2, style: "currency"})}
                  </TableCellBody>
                  <TableCellBody
                      className="main-width-class last-cell"
                      align="right"
                  >
                  {numberFormat({number:(+item?.transactions?.find((o, i) => {
                      if (o.date === "Prepays") {
                        return o;
                      }
                    })?.totalAmount), decimal: 2, style: "currency"})}
                  </TableCellBody>
              </StyledTableRow>
         
              ))}
              <StyledTableRow className=""
                style={{ width: "100%" }}
              >
                <TableCellBody 
                align='left'
                className="first-cell"
                >
                  Total
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                   {numberFormat({number:+totals?.totalsCalc, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.totalOf30Days, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.totalOf60Days, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.totalOf90Days, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.totalOfOver90Days, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop last-cell"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.totalPrepaysCalc, decimal: 2, style: "currency"})}
                </TableCellBody>
              </StyledTableRow>  
              </>
              
       </TableBody>
      </Table>
    }
      />
   
  </div>
  
  ) : reportName === "Aged account receivable summarized by Family" ? (
    <div
    className="report-doc p-10"
    style={{
      zIndex: `${downloadFile ? "-999" : "0"}`,
    }}
  >
    <ExportOptions 
      columns={report2Cols}
      datas={report2rows()}
      downloadExcel={downloadExcel}
      isLoading={isExportLoading}
      setLoading={setIsExportLoading}
      tableContainerRef={tableContainerRef}
      reportFileNameHandler={reportFileNameHandler}
    />
       <div
       ref={tableContainerRef}
     >
    {data?.map((item,index) => (
        <Report
        Title={index===0 && 'Aged Accounts Receivable by Family' }
        FromDate={index===0 && formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.date), formatType: "default"})}
        ToDate={index===0 && formatDate({date:today, formatType: "default"})}
        asOf={index===0 && formatDate({date:today, formatType: "default"})}
    
        Content={
          <Table >
             <div className="family-name">
              <span>{item?.account?.family_name}</span>
            </div>
          <TableHead>
         
              <TableRow>
                  {AgedAccountsheaders?.map((item, index) => (
                      <TableCellHead
                      align={index ===0 ? 'left':'right'}
                      style={{  
                        borderBottomLeftRadius:index === 0 ? 5:0,
                        borderTopLeftRadius:index === 0 ? 5:0,
                        borderBottomRightRadius:AgedAccountsheaders.length-1=== index ? 5:0,
                        borderTopRightRadius:AgedAccountsheaders.length-1=== index ? 5:0,
                         padding: "16px 7px",
                        }}
                      >
                          <span>
                              {item}
                          </span>
                      </TableCellHead>
                  ))}
              </TableRow>
          </TableHead>
          <TableBody style={{ backgroundColor: 'white' }}>
                  {item?.records?.map((item)=>(
                    <>
                  <StyledTableRow sx={{
                      '& > *': {
                          borderBottom: 'unset'
                      }
                    }}>

                      <TableCellBody
                          className="main-width-class first-cell"
                          align="left"
                      >
                        <div className="name">{item?.Ledger} /{item?.SubLedger}</div> 
                      </TableCellBody>
                      <TableCellBody
                          className="main-width-class"
                          align="right"
                      >
                      
                      </TableCellBody>
                      <TableCellBody
                          className="main-width-class"
                          align="right"
                      >
                        {numberFormat({number:(+item?.transactions?.find((o, i) => {
                                  if (o.date === "0-30") {
                                    return o;
                                  }
                                })?.totalAmount), decimal: 2, style: "currency"})}
                      </TableCellBody>
                      <TableCellBody
                          className="main-width-class"
                          align="right"
                      >
                        {numberFormat({number:(+item?.transactions?.find((o, i) => {
                                  if (o.date === "30-60") {
                                    return o;
                                  }
                                })?.totalAmount), decimal: 2, style: "currency"})}
                      </TableCellBody>
                      <TableCellBody
                          className="main-width-class"
                          align="right"
                      >
                        {numberFormat({number:(+item?.transactions?.find((o, i) => {
                                  if (o.date === "60-90") {
                                    return o;
                                  }
                                })?.totalAmount), decimal: 2, style: "currency"})}
                      </TableCellBody>
                      <TableCellBody
                          className="main-width-class"
                          align="right"
                      >
                        {numberFormat({number:(+item?.transactions?.find((o, i) => {
                                  if (o.date === "90+") {
                                    return o;
                                  }
                                })?.totalAmount), decimal: 2, style: "currency"})}
                      </TableCellBody>
                      <TableCellBody
                          className="main-width-class last-cell"
                          align="right"
                      >
                        {numberFormat({number:(+item?.transactions?.find((o, i) => {
                                  if (o.date === "Prepays") {
                                    return o;
                                  }
                                })?.totalAmount), decimal: 2, style: "currency"})}
                      </TableCellBody>
                  </StyledTableRow>
                    </>

                  ))}
                   <StyledTableRow className=""
                style={{ width: "100%" }}
              >
                <TableCellBody style={{ width: "20%" }}
                align='right'
                ></TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{ width: "100px", overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+item?.total, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop textelips"
                  align='right'
                  style={{ width: "100px", overflowWrap: "break-word" }}
                  title={numberFormat({number:item?.records
                    ?.map((hh) => {
                      return (
                        hh?.transactions?.find((o, i) => {
                          if (o.date === "0-30") {
                            return o;
                          }
                        })?.totalAmount ?? 0
                      );
                    })
                    ?.reduce((partialSum, a) => partialSum + a, 0), decimal: 2, style: "currency"})}
                >
                  {numberFormat({number:(+item?.records
                          ?.map((hh) => {
                            return (
                              hh?.transactions?.find((o, i) => {
                                if (o.date === "0-30") {
                                  return o;
                                }
                              })?.totalAmount ?? 0.0
                            );
                          })
                          ?.reduce(
                            (partialSum, a) => partialSum + a,
                            0
                          )), decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  align='right'
                  className="borderTop textelips"
                  style={{ width: "100px", overflowWrap: "break-word" }}
                  title={numberFormat({number:item?.records
                    ?.map((hh) => {
                      return (
                        hh?.transactions?.find((o, i) => {
                          if (o.date === "30-60") {
                            return o;
                          }
                        })?.totalAmount ?? 0
                      );
                    })
                    ?.reduce((partialSum, a) => partialSum + a, 0), decimal: 2, style: "currency"})}
                >
                  {numberFormat({number:(+item?.records
                          ?.map((hh) => {
                            return (
                              hh?.transactions?.find((o, i) => {
                                if (o.date === "30-60") {
                                  return o;
                                }
                              })?.totalAmount ?? 0
                            );
                          })
                          ?.reduce(
                            (partialSum, a) => partialSum + a,
                            0
                          )) , decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  align='right'
                  className="borderTop textelips"
                  style={{ width: "100px", overflowWrap: "break-word" }}
                  title={numberFormat({number:item?.records
                    ?.map((hh) => {
                      return (
                        hh?.transactions?.find((o, i) => {
                          if (o.date === "60-90") {
                            return o;
                          }
                        })?.totalAmount ?? 0
                      );
                    })
                    ?.reduce((partialSum, a) => partialSum + a, 0), decimal: 2, style: "currency"})}
                >
                  {numberFormat({number:(+item?.records
                          ?.map((hh) => {
                            return (
                              hh?.transactions?.find((o, i) => {
                                if (o.date === "60-90") {
                                  return o;
                                }
                              })?.totalAmount ?? 0
                            );
                          })
                          ?.reduce(
                            (partialSum, a) => partialSum + a,
                            0
                          )) , decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  align='right'
                  className="borderTop textelips"
                  style={{ width: "100px", overflowWrap: "break-word" }}
                  title={numberFormat({number:item?.records
                    ?.map((hh) => {
                      return (
                        hh?.transactions?.find((o, i) => {
                          if (o.date === "90+") {
                            return o;
                          }
                        })?.totalAmount ?? 0
                      );
                    })
                    ?.reduce((partialSum, a) => Number(partialSum + a, 0)), decimal: 2, style: "currency"})}
                >
                  {numberFormat({number:
                        (+item?.records
                          ?.map((hh) => {
                            return (
                              hh?.transactions?.find((o, i) => {
                                if (o.date === "90+") {
                                  return o;
                                }
                              })?.totalAmount ?? 0
                            );
                          })
                          ?.reduce(
                            (partialSum, a) => partialSum + a,
                            0
                          )) , decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  align='right'
                  className="borderTop textelips last-cell"
                  style={{ width: "100px", overflowWrap: "break-word" }}
                  title={numberFormat({number:item?.records
                    ?.map((hh) => {
                      return (
                        hh?.transactions?.find((o, i) => {
                          if (o.date === "Prepays") {
                            return o;
                          }
                        })?.totalAmount ?? 0
                      );

                    })
                    ?.reduce((partialSum, a) => partialSum + a, 0), decimal: 2, style: "currency"})}
                >
                  {numberFormat({number:(+item?.records
                          ?.map((hh) => {
                            return (
                              hh?.transactions?.find((o, i) => {
                                if (o.date === "Prepays") {
                                  return o;
                                }
                              })?.totalAmount ?? 0
                            );
                          })
                          ?.reduce(
                            (partialSum, a) => partialSum + a,
                            0
                          )) , decimal: 2, style: "currency"})}
                </TableCellBody>
              </StyledTableRow>        
                
          </TableBody>
          </Table>
        }
      />
      ))}
      </div>
  </div>
  ) : reportName === "Billing Summarized by Ledger" ? (
     <div
      className="report-doc p-10"
      style={{
        zIndex: `${downloadFile ? "-999" : "0"}`,
      }}
    >
      <ExportOptions 
        columns={
          reportIndex == "0"
            ? report1Cols
            : reportIndex == "1"
            ? ""
            : reportIndex == "2"
            ? report3Cols
            : ""
        }
        datas={reportIndex == "0" ? report1rows() : report3rows()}
        downloadExcel={downloadExcel}
        isLoading={isExportLoading}
        setLoading={setIsExportLoading}
        tableContainerRef={tableContainerRef}
        reportFileNameHandler={reportFileNameHandler}
        />
      <Report 
      Title={'Billing Information Summarized by category'}
      FromDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.start), formatType: "default"})}
      ToDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.end), formatType: "default"})}
      asOf={formatDate({date:today, formatType: "default"})}
      tableContainerRef={tableContainerRef}
      Content={
        <Table >
        <TableHead>
            <TableRow>
                {BillingByLedgerheaders?.map((item, index) => (
                    <TableCellHead
                    align={index === 0 ?'left' : 'right'}
                    style={{  
                      borderBottomLeftRadius:index === 0 ? 5:0,
                      borderTopLeftRadius:index === 0 ? 5:0,
                      borderBottomRightRadius:BillingByLedgerheaders.length-1=== index ? 5:0,
                      borderTopRightRadius:BillingByLedgerheaders.length-1=== index ? 5:0,
                      padding: "16px 7px"
                      }}
                    >
                        <span>
                            {item}
                        </span>
                    </TableCellHead>
                ))}
            </TableRow>
        </TableHead>
        <TableBody style={{ backgroundColor: 'white' }}>
                {data?.map((item)=>(
                  <StyledTableRow sx={{
                    '& > *': {
                        borderBottom: 'unset',
                        background:'#ffff',
                        border:'none !importent',
                    }
                }}
                >
                    <TableCell
                        className="main-width-class first-cell"
                        align="left"
                        style={{width: 0,border: 0,padding:7}}
                    >
                      <div className="name">{item?.Ledger} / {item?.SubLedger}</div> 
                    </TableCell>
                    <TableCell
                        align="right"
                        style={{width: 0,border: 0,padding:7}}
                    >
                      {item?.families}
                    </TableCell>
                    <TableCell
                        align="right"
                        style={{width: 0,border: 0,padding:7}}
                    >
                    {numberFormat({number:+item?.billed, decimal: 2, style: "currency"})}
                    </TableCell>
                    <TableCell
                        align="right"
                        style={{width: 0,border: 0,padding:7}}
                    >
                      {numberFormat({number:+item?.paid, decimal: 2, style: "currency"})}
                    </TableCell>
                    <TableCell
                        align="right"
                        style={{width: 0,border: 0,padding:7}}
                    >
                      {numberFormat({number:+item?.adjusted, decimal: 2, style: "currency"})}
                    </TableCell>
                    <TableCell
                        align="right"
                        style={{width: 0,border: 0,padding:7}}
                        className="last-cell"
                    >
                    {numberFormat({number:+item?.balance, decimal: 2, style: "currency"})}
                    </TableCell>
                </StyledTableRow>
                ))}
                           
              <StyledTableRow className=""
                style={{ width: "100%" }}
              >
                <TableCellBody
                  className="borderTop first-cell"
                  align='left'
                  style={{ overflowWrap: "break-word" }}
                >
                    Total
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{ overflowWrap: "break-word" }}
                >
                    {totals?.totalsOfFamilies} Families
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{ overflowWrap: "break-word" }}
                >
                    {numberFormat({number:+totals?.totalsOfBilled, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{ overflowWrap: "break-word" }}
                >
                    {numberFormat({number:+totals?.totalsOfPaid, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{ overflowWrap: "break-word" }}
                >
                    {numberFormat({number:+totals?.totalsOfAdjusted, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop last-cell"
                  align='right'
                  style={{ overflowWrap: "break-word" }}
                >
                    {numberFormat({number:+totals?.totalsOfBalance, decimal: 2, style: "currency"})}
                </TableCellBody>
              </StyledTableRow>
        </TableBody>
        </Table>
      }
      />
    </div>
  ) : reportName === "Batch details"? (
    <div
    className="report-doc p-10"
    style={{
      zIndex: `${downloadFile ? "-999" : "0"}`,
    }}
  >
    <ExportOptions 
        columns={report4Cols}
        datas={report4rows()}
        downloadExcel={downloadExcel}
        isLoading={isExportLoading}
        setLoading={setIsExportLoading}
        tableContainerRef={tableContainerRef}
        reportFileNameHandler={reportFileNameHandler}

        />
    <div ref={tableContainerRef}>
    <div className="d-flex justify-content-between w-75">
      <p>Printed on : {formatDate({date:today, formatType: "default"})}</p>
      <h1 className="text-center heading underLine">
        Detail by Batch Sorted by Batch Number
      </h1>
    </div>
    {data?.map((item) => {
      return (
        <>
          <table className="w-100 mt-10">
            <tr>
              <th style={{ width: "80%" }}>Batch-CP081022</th>
              <th className="underLine">Debit</th>
              <th className="underLine">Credit</th>
            </tr>
          </table>
          <div className="d-flex justify-content-between">
            {/* <th>check#: 12302</th> */}
            <th>
              Deposit Date:
              {formatDate({date:item?.date, formatType: "default"})}
              total:
              {numberFormat({number:+item?.TotalAmount, decimal: 2, style: "currency"})}
            </th>
          </div>
          <table className="w-100">
            {item?.transactions?.map((tran) => {
              return (
                <>
                  <tr>
                    <th className="text-left" style={{ width: "80%" }}>
                      {tran?.accountReceivableLedge
                        ? tran?.accountReceivableLedger?.id?.ar_name
                        : tran?.accountReceivableLedger?.id?.ar_name}
                    </th>
                  </tr>
                  <tr>
                    <th className="text-left" style={{ width: "80%" }}>
                      {tran?.account?.name}
                    </th>
                    <th className="text-left">
                      {numberFormat({number:+tran?.debit, decimal: 2, style: "currency"})}
                    </th>
                    <th className="text-left">
                      {numberFormat({number:+tran?.credit, decimal: 2, style: "currency"})}
                    </th>
                  </tr>
                </>
              );
            })}
          </table>
        </>
      );
    })}
    </div>
  </div>
  ) : reportName === "Ledger report"? (
    <div
    className="report-doc p-10"
    style={{
      zIndex: `${downloadFile ? "-999" : "0"}`,
    }}
  >
      <ExportOptions 
        columns={report5Cols}
        datas={report5rows()}
        downloadExcel={downloadExcel}
        isLoading={isExportLoading}
        setLoading={setIsExportLoading}
        tableContainerRef={tableContainerRef}
        reportFileNameHandler={reportFileNameHandler}
        />
    <div ref={tableContainerRef}>

    {data?.length ? data?.map((item,index) => {
      return (
        <Report 
        Title={index===0 && 'Ledger summary by account' }
        FromDate={index===0 &&formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.start), formatType: "default"})}
        ToDate={index===0 &&formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.end), formatType: "default"})}
        asOf={index===0 && formatDate({date:today, formatType: "default"})}
        Content={
          <Table >
          <TableHead>
              <TableRow>
                  {LedgerReport?.map((item, index) => (
                      <TableCellHead
                      align={index === 0 ?"left":"right"}
                      style={{  
                        borderBottomLeftRadius:index === 0 ? 5:0,
                        borderTopLeftRadius:index === 0 ? 5:0,
                        borderBottomRightRadius:LedgerReport.length-1=== index ? 5:0,
                        borderTopRightRadius:LedgerReport.length-1=== index ? 5:0,
                        padding: "16px 7px"
                        }}
                      >
                          <span>
                              {item}
                          </span>
                      </TableCellHead>
                  ))}
              </TableRow>
          </TableHead>
          <TableBody style={{ backgroundColor: 'white' }}>
                  {item?.transactions?.map((tran) => (
                    <>
                  <StyledTableRow sx={{
                      '& > *': {
                          borderBottom: 'unset'
                      }
                    }}>
                    <TableCellBody
                          className="main-width-class first-cell"
                          align="left"
                      >
                      {tran?.batchId}
                      </TableCellBody>
                      <TableCellBody
                          className="main-width-class"
                          align="right"
                      >
                        {formatDate({date:tran?.date, formatType: "default"})}
                      </TableCellBody>
                     
                      <TableCellBody
                          className="main-width-class"
                          align="right"
                      >
                      {numberFormat({number:+tran?.debit, decimal: 2, style: "currency"})}
                      </TableCellBody>

                      <TableCellBody
                          className="main-width-class"
                          align="right"
                      >
                      {numberFormat({number:+tran?.credit, decimal: 2, style: "currency"})}
                      </TableCellBody>
                  </StyledTableRow>
                    </>

                  ))}
                            
              <StyledTableRow>
              <TableCellBody className="borderTop" align="right"></TableCellBody>
              <TableCellBody className="borderTop" align="right"></TableCellBody>
              <TableCellBody className="borderTop" align="right">
                {numberFormat({number:(+item?.transactions
                        ?.map((tran) => {
                          return tran?.debit;
                        })
                        ?.reduce(
                          (partialSum, a) => partialSum + a,
                          0
                        )), decimal: 2, style: "currency"})}
              </TableCellBody>
              <TableCellBody className="borderTop" align="right">
                {numberFormat({number:(+item?.transactions
                        ?.map((tran) => {
                          return tran?.credit;
                        })
                        ?.reduce(
                          (partialSum, a) => partialSum + a,
                          0
                        )), decimal: 2, style: "currency"})}
              </TableCellBody>
              <TableCellBody className="borderTop last-cell" align="right">
                {numberFormat({number:(+item?.transactions
                          ?.map((tran) => {
                            return tran?.debit;
                          })
                          ?.reduce((partialSum, a) => partialSum + a, 0) +
                        item?.transactions
                          ?.map((tran) => {
                            return tran?.credit;
                          })
                          ?.reduce((partialSum, a) => partialSum + a, 0)
                      ),decimal: 2, style: "currency"})}
              </TableCellBody>
            </StyledTableRow>
          </TableBody>
          </Table>
        }
      />
       
      );
    }) : (
        <Report 
        Title={'Ledger summary by account' }
        FromDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.start), formatType: "default"})}
        ToDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.end), formatType: "default"})}
        asOf={formatDate({date:today, formatType: "default"})}
        Content={
          <Table >
          <TableHead>
              <TableRow>
                  {LedgerReport?.map((item, index) => (
                      <TableCellHead
                      align={index === 0 ?"left":"right"}
                      style={{  
                        borderBottomLeftRadius:index === 0 ? 5:0,
                        borderTopLeftRadius:index === 0 ? 5:0,
                        borderBottomRightRadius:LedgerReport.length-1=== index ? 5:0,
                        borderTopRightRadius:LedgerReport.length-1=== index ? 5:0,
                        padding: "16px 7px"
                        }}
                      >
                          <span>
                              {item}
                          </span>
                      </TableCellHead>
                  ))}
              </TableRow>
          </TableHead>
          
          </Table>
        }
      />
       
      
    )}
    </div>

  </div>
   
  ) :
  reportName === "Ledger account summary" ? (
  <div
  className="report-doc p-10"
  style={{
    zIndex: `${downloadFile ? "-999" : "0"}`,
  }}
>
    <ExportOptions 
      columns={report6Cols}
      datas={report6rows()}
      downloadExcel={downloadExcel}
      isLoading={isExportLoading}
      setLoading={setIsExportLoading}
      tableContainerRef={tableContainerRef}
      reportFileNameHandler={reportFileNameHandler}
    />
  <Report 
    Title={'Ledger account summary'}
    FromDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.start), formatType: "default"})}
    ToDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.end), formatType: "default"})}
    asOf={formatDate({date:today, formatType: "default"})}
    tableContainerRef={tableContainerRef}
    Content={
      <Table >
      <TableHead>
          <TableRow>
              {LedgerAccountSummaryheaders?.map((item, index) => (
                  <TableCellHead
                  align={index ===0 ? 'left':'right'}
                  style={{  
                    borderBottomLeftRadius:index === 0 ? 5:0,
                    borderTopLeftRadius:index === 0 ? 5:0,
                    borderBottomRightRadius:LedgerAccountSummaryheaders.length-1=== index ? 5:0,
                    borderTopRightRadius:LedgerAccountSummaryheaders.length-1=== index ? 5:0,
                    padding: "16px 7px"
                    }}
                  >
                      <span>
                          {item}
                      </span>
                  </TableCellHead>
              ))}
          </TableRow>
      </TableHead>
      <TableBody style={{ backgroundColor: 'white' }}>
              {data?.map((item)=>(
                <StyledTableRow sx={{
                  '& > *': {
                      borderBottom: 'unset'
                  }
              }}
              >
                  <TableCellBody
                      className="main-width-class first-cell"
                      align="left"
                  >
                    <div className="name">{item?.Ledger} / {item?.SubLedger}</div> 
                  </TableCellBody>
                  <TableCellBody
                      className="main-width-class"
                      align="right"
                  >
                   {numberFormat({number:+item?.total, decimal: 2, style: "currency"})}
                  </TableCellBody>
                  {item?.transactions?.map((tran) => {
                  if (tran?.date == "0-30") {
                    return (
                        <TableCellBody
                        className="main-width-class"
                        align="right"
                        key={tran?.date}
                        >
                        {`${numberFormat({number:tran.totalAmount, decimal: 2, style: "currency"})}`}
                      </TableCellBody>
                    );
                  }
                })}
              {item?.transactions?.map((tran) => {
                if (tran?.date == "30-60") {
                  return (
                    <TableCellBody
                    className="main-width-class"
                    align="right"
                    key={tran?.date}
                    >
                      {numberFormat({number:+tran.totalAmount, decimal: 2, style: "currency"})}
                    </TableCellBody>
                  );
                }
              })}
              {item?.transactions?.map((tran) => {
                if (tran?.date == "60-90") {
                  return (
                    <TableCellBody
                    className="main-width-class"
                    align="right"
                    key={tran?.date}
                    >
                      {numberFormat({number:+tran.totalAmount, decimal: 2, style: "currency"})}
                    </TableCellBody>
                  );
                }
              })}
              {item?.transactions?.map((tran) => {
                if (tran?.date == "90+") {
                  return (
                    <TableCellBody
                    className="main-width-class"
                    align="right"
                    key={tran?.date}
                    >
                      {numberFormat({number:+tran.totalAmount, decimal: 2, style: "currency"})}
                    </TableCellBody>
                  );
                }
              })}
              {item?.transactions?.map((tran) => {
                if (tran?.date == "Prepays") {
                  return (
                    <TableCellBody
                            className="main-width-class last-cell"
                            align="right"
                            key={tran?.date}
                            >
                      {numberFormat({number:+tran.totalAmount, decimal: 2, style: "currency"})}
                    </TableCellBody>
                  );
                }
              })}
              </StyledTableRow>
              ))}
              {!!data?.length && (<StyledTableRow className=""
                style={{ width: "100%" }}
              >
                <TableCellBody 
                align='left'
                className="first-cell"
                >
                  Total
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.ledgerTotalsCalc, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.totalOf30Days, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.totalOf60Days, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.totalOf90Days, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.totalOfOver90Days, decimal: 2, style: "currency"})}
                </TableCellBody>
                <TableCellBody
                  className="borderTop last-cell"
                  align='right'
                  style={{  overflowWrap: "break-word" }}
                >
                  {numberFormat({number:+totals?.ledgerTotalPrepaysCalc, decimal: 2, style: "currency"})}
                </TableCellBody>
              </StyledTableRow>)}
       </TableBody>
      </Table>
    }
      />
 
</div>
) : reportName === "Credit on Account" ? (
  <div className="report-doc p-10">
    <ExportOptions
      columns={creditOnAccountCols}
      datas={creditOnAccountRows()}
      downloadExcel={downloadExcel}
      isLoading={isExportLoading}
      setLoading={setIsExportLoading}
      tableContainerRef={tableContainerRef}
      reportFileNameHandler={reportFileNameHandler}
    />
    <Report
      Title={"Credit on Account"}
      asOf={formatDate({ date: today, formatType: "default" })}
      tableContainerRef={tableContainerRef}
      Content={
        <Table>
          <TableHead>
            <TableRow>
              {["Account ID", "Account Name", "Balance"].map((header, index) => (
                <TableCellHead
                  key={header}
                  align={index === 2 ? "right" : "left"}
                  style={{
                    borderBottomLeftRadius: index === 0 ? 5 : 0,
                    borderTopLeftRadius: index === 0 ? 5 : 0,
                    borderBottomRightRadius: index === 2 ? 5 : 0,
                    borderTopRightRadius: index === 2 ? 5 : 0,
                    padding: "16px 7px",
                  }}
                >
                  <span>{header}</span>
                </TableCellHead>
              ))}
            </TableRow>
          </TableHead>
          <TableBody style={{ backgroundColor: "white" }}>
            {data?.map((item) => (
              <StyledTableRow key={item._id} sx={{ "& > *": { borderBottom: "unset" } }}>
                <TableCellBody className="main-width-class first-cell" align="left">
                  <div className="name">#{item?.accountId}</div>
                </TableCellBody>
                <TableCellBody className="main-width-class" align="left">
                  {item?.accountName}
                </TableCellBody>
                <TableCellBody className="main-width-class last-cell" align="right">
                  {numberFormat({ number: +item?.balance, decimal: 2, style: "currency" })}
                </TableCellBody>
              </StyledTableRow>
            ))}
            {data?.length > 0 && (
              <StyledTableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                <TableCellBody className="borderTop first-cell" align="left">Total</TableCellBody>
                <TableCellBody className="borderTop" align="right"></TableCellBody>
                <TableCellBody className="borderTop last-cell" align="right">
                  {numberFormat({
                    number: data?.reduce((sum, item) => sum + (+item?.balance || 0), 0),
                    decimal: 2,
                    style: "currency",
                  })}
                </TableCellBody>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      }
    />
  </div>
) : null
};
export default report1;
